import { createContext, useContext, ReactNode } from "react"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"

interface OrganizationSettingsContextType {
  organization: Omit<OrganizationsResponses.Organization, "users">
  displaySettingsId: string | null
  displaySettings: OrganizationsResponses.Organization["settings"]["displaySettings"]
}

const OrganizationSettingsContext = createContext<
  OrganizationSettingsContextType | undefined
>(undefined)

interface OrganizationSettingsProviderProps {
  children: ReactNode
  organization: Omit<OrganizationsResponses.Organization, "users">
}

export const OrganizationSettingsProvider = ({
  children,
  organization,
}: OrganizationSettingsProviderProps) => {
  const displaySettingsId =
    organization.settings.displaySettings.length > 0
      ? organization.settings.displaySettings[0].id
      : null

  const value = {
    organization,
    displaySettingsId,
    displaySettings: organization.settings.displaySettings,
  }

  return (
    <OrganizationSettingsContext.Provider value={value}>
      {children}
    </OrganizationSettingsContext.Provider>
  )
}

export const useOrganizationSettings = () => {
  const context = useContext(OrganizationSettingsContext)
  if (context === undefined) {
    throw new Error(
      "useOrganizationSettings must be used within an OrganizationSettingsProvider"
    )
  }
  return context
}
